import { render, staticRenderFns } from "./NewCognitiveLevelST.vue?vue&type=template&id=c7cb6954&scoped=true"
import script from "./NewCognitiveLevelST.vue?vue&type=script&lang=js"
export * from "./NewCognitiveLevelST.vue?vue&type=script&lang=js"
import style0 from "./NewCognitiveLevelST.vue?vue&type=style&index=0&id=c7cb6954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7cb6954",
  null
  
)

export default component.exports